<!-- 柱状图 -->
<template>
    <div class="width_height_100" :id="id"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
    name: "EchartBar",
    data() {
        return {
        };
    },
    props: {
        id: {
            type: String,
            default: "bar",
        },
        xValue: {
            type: Array,
            default: function () {
                return [0, 0, 0, 0, 0];
            },
        },
        yValue: {
            type: Array,
            default: function () {
                return [
                    "合肥",
                ];
            },
        },
    },
    mounted() {
        this.show();
    },
    methods: {
        show() {
            var chartDom = document.getElementById(this.id);
            var myChart = echarts.init(chartDom);
            var option;
            option = {
                color: ["#d84430"],
                tooltip: {
                    show: true,
                },
                yAxis: {
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        color: "#747B95",
                    },
                    data: this.yValue,
                },
                xAxis: {
                    nameTextStyle: {
                        color: "rgba(255, 255, 255, 0.8)",
                    },
                    splitLine: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        color: "rgba(255, 255, 255, 0.8)",
                    },
                },
                grid: {
                    top: "0%",
                    bottom: "0%",
                    left: "100px",
                    right: "0%",
                },
                series: [
                    {
                        name: "",
                        barWidth: 10,
                        type: "bar",
                        data: this.xValue,
                        itemStyle: {
                            normal: {
                                borderRadius: [3, 3, 3, 3],
                                color: function (params) {
                                    // 设置柱形图的颜色
                                    if (params.dataIndex === 4) {
                                        return "#58D0FF";
                                    } else if (params.dataIndex === 3) {
                                        return "#8479FF";
                                    } else if (params.dataIndex === 2) {
                                        return "#FFC935";
                                    } else if (params.dataIndex === 1) {
                                        return "#FF6161";
                                    } else if (params.dataIndex === 0) {
                                        return "#BF5BFF";
                                    }
                                },
                            },
                        },
                    },
                ],
            };
            option && myChart.setOption(option);
        },
    },
};
</script>
    
<style scoped>
.width_height_100 {
    width: 100%;
    height: 100%;
}
</style>